module.exports = __webpack_public_path__ + "static/img/Ethan-Bullemor.bc6ec7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ethan-Bullemor.jpg
// module id = BuMx
// module chunks = 0